import { useSubscription } from '@apollo/client/react';
import { useRouter } from 'next/router';

import { useAuth } from '@pflegia/ui/contexts/auth.context';

import { SUBSCRIPTION_NEW_APPLICATION, SUBSCRIPTION_NEW_MESSAGES, SUBSCRIPTION_NEW_OFFER } from '@shared/graphql/subscriptions';

import { CHAT_ROOT } from './constants';
import { writeUnreadApplicationsQuery, writeUnreadMessagesQuery, writeUnreadOffersQuery } from './write-notification-cache';

/**
 * Subscribe to notifications about new offers, applications and messages.
 * Update the cached queries about those when receiving new subscription messages.
 */
export const useSubscribeToNotifications = () => {
  const authenticated = useAuth();
  const { pathname } = useRouter();

  useSubscription<{ newOffer: { key: string; newNotifications: boolean } }>(SUBSCRIPTION_NEW_OFFER, {
    onData(option) {
      writeUnreadOffersQuery(option.client.cache, option.data.data?.newOffer.newNotifications ? 1 : 0);
    },
    skip: !authenticated,
  });

  useSubscription<{ newApplication: { key: string; newNotifications: boolean } }>(SUBSCRIPTION_NEW_APPLICATION, {
    onData(option) {
      writeUnreadApplicationsQuery(option.client.cache, option.data.data?.newApplication.newNotifications ? 1 : 0);
    },
    skip: !authenticated,
  });

  useSubscription<{ chatNotificationForUser: { key: string; newNotifications: boolean } }>(SUBSCRIPTION_NEW_MESSAGES, {
    onData(option) {
      writeUnreadMessagesQuery(option.client.cache, option.data.data?.chatNotificationForUser.newNotifications ? 1 : 0);
    },
    skip: !authenticated || pathname.startsWith(CHAT_ROOT),
  });
};
